import { HotelPriceIncludesType, useGlobalContext } from '@honeycomb/data';
import { Stacker, KnifeAndForkIcon, TypographyBody, Skeleton, BedIcon, FlexGrid, TypographyHeading, Anchor, useBreakpoints, } from '@honeycomb/ui-core';
import React from 'react';
import { pluraliseCount } from '../../../../../utils';
import { useHotelBasketContext } from '../../../HotelBasketProvider';
import { HotelBasketSection } from './HotelBasketSection';
import { useHotelDetailsContext } from '../../../HotelDetails/HotelDetails.context';
import { HotelDetailsActionType } from '../../../HotelDetails';
import { HotelPriceIncludes } from '../../../HotelPriceIncludes';
export function HotelBasketRooms() {
    var _a;
    const { resourceStrings: { EDIT_LINK_LABEL }, } = useGlobalContext();
    const { hotelBasket } = useHotelBasketContext();
    const { largeUp } = useBreakpoints();
    const isMobileLayout = !largeUp;
    const { selectedRooms, waitingForRooms } = hotelBasket;
    const { state: { onScrollToSection }, dispatch, } = useHotelDetailsContext();
    const handleClick = React.useCallback(() => {
        if (isMobileLayout) {
            dispatch({
                type: HotelDetailsActionType.SET_MOBILE_DRAWER_OPEN,
                payload: false,
            });
        }
        setTimeout(() => {
            onScrollToSection === null || onScrollToSection === void 0 ? void 0 : onScrollToSection('rooms');
        }, 500);
    }, [dispatch, isMobileLayout, onScrollToSection]);
    if (waitingForRooms) {
        // Return skeleton loading state
        return (React.createElement(Stacker, { spacing: 2 },
            React.createElement(HotelBasketSection, { icon: React.createElement(KnifeAndForkIcon, null), title: "Board Basis", relatedSection: "rooms", waiting: true, dataId: "board-basic-summary-waiting" },
                React.createElement(TypographyBody, { component: "div", size: "xs" },
                    React.createElement(Skeleton, { variant: "text", w: 120 }))),
            React.createElement(HotelBasketSection, { icon: React.createElement(BedIcon, null), title: "Room", relatedSection: "rooms", waiting: true, dataId: "rooms-summary-waiting" },
                React.createElement(Stacker, { spacing: 1 },
                    React.createElement(TypographyBody, { component: "div", size: "xs" },
                        React.createElement(Skeleton, { variant: "text", w: 90 })),
                    React.createElement(Stacker, { spacing: 2 }, ['55%', '40%'].map((width) => {
                        return (React.createElement(TypographyBody, { component: "div", size: "xs", key: width },
                            React.createElement(Skeleton, { variant: "text", w: width })));
                    }))))));
    }
    const boardBasis = (_a = selectedRooms === null || selectedRooms === void 0 ? void 0 : selectedRooms[0]) === null || _a === void 0 ? void 0 : _a.boardTypeDescription;
    const numberOfRooms = selectedRooms.length;
    const isMultiRoom = numberOfRooms > 1;
    return (React.createElement(Stacker, { spacing: 2 },
        React.createElement(HotelBasketSection, { icon: React.createElement(KnifeAndForkIcon, null), title: "Board Basis", relatedSection: "rooms", dataId: "board-basic-summary" },
            React.createElement(TypographyBody, { size: "xs", "data-id": "selected-board-basis" }, boardBasis)),
        React.createElement(HotelBasketSection, { icon: React.createElement(BedIcon, null), title: isMultiRoom
                ? pluraliseCount(numberOfRooms, {
                    singular: `${numberOfRooms} Room`,
                    plural: `${numberOfRooms} Rooms`,
                })
                : 'Room', relatedSection: "rooms", collapsible: isMultiRoom, dataId: "board-basic-summary" },
            React.createElement(Stacker, { spacing: 3, mt: isMultiRoom ? 3 : undefined }, hotelBasket.selectedRooms.map((room, index) => {
                const { pricingSummary } = room;
                const roomNo = index + 1;
                return (React.createElement(FlexGrid, { container: true, disableEqualOverflow: true, key: roomNo },
                    React.createElement(FlexGrid, { xs: "fill" },
                        React.createElement(Stacker, { spacing: 1, key: roomNo },
                            isMultiRoom && (React.createElement(TypographyHeading, { size: "2xs", color: "text.body", component: "h5", "data-id": `selected-room${roomNo}` }, `Room ${roomNo}`)),
                            React.createElement(TypographyBody, { size: "xs", "data-id": `selected-room${roomNo}-desc` }, room.roomDescription),
                            React.createElement(HotelPriceIncludes, { pricingSummary: pricingSummary, typesToDisplay: [
                                    HotelPriceIncludesType.LOCAL_CHARGES,
                                    HotelPriceIncludesType.HYPE_MESSAGES,
                                ], ItemProps: { LabelProps: { size: 'xs' } } }))),
                    isMultiRoom && (React.createElement(FlexGrid, { xs: "hold" },
                        React.createElement(Anchor, { button: true, color: "text.link", size: "xs", weight: "semiBold", va: "top", onClick: handleClick, "data-id": `selected-room${roomNo}-edit-icon` }, EDIT_LINK_LABEL)))));
            })))));
}
